import React from 'react';
import { Form, Input, message, Modal } from 'antd';
import { saveUser, updateUser, UserVo } from '@/api/user';

export interface EditUserProp {
  data?: UserVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditUser = ({ data, isEdit, updateFn, onCancel }: EditUserProp) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    form.validateFields().then(values => {
      const api = isEdit ? updateUser : saveUser;
      api({ ...values, id: data?.id }).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal title={isEdit ? '编辑用户' : '新增用户'} open={true} onCancel={onCancel} onOk={onFinish} maskClosable={false}>
      <Form form={form} layout="vertical" initialValues={data}>
        <Form.Item name="name" label="姓名" rules={[{ required: true, message: '请输入' }]}>
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item name="username" label="账号" rules={[{ required: true, message: '请输入' }]}>
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入' }]}>
          <Input.Password placeholder="请输入" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUser;
